import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { BriefcaseIcon } from 'lucide-react';
export function EmploymentSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="employment" className="py-20 bg-white" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div ref={ref} className={`bg-primary rounded-3xl overflow-hidden shadow-2xl relative transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-58">
          {/* Background image with overlay */}
          <div className="absolute inset-0" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/csErpeqbAwz88wZ1xNijkU/4.jpg" alt="Healthcare professionals team" className="w-full h-full object-cover" data-id="element-60" />
            <div className="absolute inset-0 bg-primary/85" data-id="element-61"></div>
          </div>
          {/* Decorative background pattern */}
          <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
          backgroundSize: '40px 40px'
        }} data-id="element-62"></div>

          <div className="relative z-10 px-8 py-16 md:p-20 flex flex-col md:flex-row items-center justify-between text-center md:text-left" data-id="element-63">
            <div className="md:w-2/3 mb-10 md:mb-0 md:pr-10" data-id="element-64">
              <div className="inline-flex items-center justify-center bg-white/20 p-3 rounded-xl mb-6 backdrop-blur-sm" data-id="element-65">
                <BriefcaseIcon className="h-8 w-8 text-white" data-id="element-66" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-67">
                Join Our Caring Team
              </h2>
              <p className="text-lg text-white/90 max-w-2xl" data-id="element-68">
                Make a difference in people's lives every day. We're looking for
                compassionate healthcare professionals to join our growing team.
              </p>
            </div>

            <div className="md:w-1/3 flex justify-center md:justify-end" data-id="element-69">
              <a href="#/employment" className="inline-block bg-white text-primary-dark hover:bg-light-alt px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap" data-id="element-70">
                View Employment Opportunities
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}